import { E_YesNo, E_YesNoNumber, IPageData, IPageParams } from "../types";
import { E_CollectMode, E_StartStatus } from "./sensor.types";
import { ISensorAlarmBase } from "./sensorAlarm.types";
import { E_CommChoice } from "./sensorNew.types";

/**
 * APEF状态
 */
export enum E_ApefStatus {
    /**
     * 启用
     */
    Enabled = 1,
    /**
     * 禁用
     */
    Disabled = 0,
}

/**
 * 自诊断状态
 * $t('enum.E_FaultStatus.Enabled')
 * $t('enum.E_FaultStatus.Disabled')
 */
export enum E_FaultStatus {
    /**
     * 启用
     */
    Enabled = 1,
    /**
     * 禁用
     */
    Disabled = 0,
}

/**
 *  $t('enum.E_UseLearnStatus.Using')
 * $t('enum.E_UseLearnStatus.NotUsing')
 */
export enum E_UseLearnStatus {
    /**
     * 使用中
     */
    Using = 1,
    /**
     * 未使用
     */
    NotUsing = 2,
}

/**
 * 传感器斜率报警状态
 * $t('enum.E_SlopeStartStatus.Open')
 * $t('enum.E_SlopeStartStatus.Close')
 */
export enum E_SlopeStartStatus {
    /**
     * 开启
     */
    Open = 1,
    /**
     * 关闭
     */
    Close = 2
}

export type ISensorThreshPageListParams = Partial<{
    /*
    */
    companyId: number
    /*
    */
    areaId: number
    /*
    */
    equipmentId: number
    /*
    */
    equipmentType: number
    /*
    */
    isFault: number
    /*
    */
    sensorId: number
    /*
    */
    sensorType: string
    /*
    */
    sleepT: number
}> & IPageParams


export interface ISensorAlarmSettingListItem extends ISensorAlarmBase {
    id: number
    mappingId: number
}

export interface ISensorThreshPageItem {
    companyId
    areaId
    equipmentId
    cardChannelId
    cardId
    cardName
    channelName
    channelType
    collectMode: E_CollectMode
    commChoice: E_CommChoice
    companyAreaName: string
    equipmentName
    gatewayId
    gatewayName
    /**
     * 测点id
     */
    id: number
    isFault: E_FaultStatus
    /**
     * APEF
     */
    openLearn: E_YesNoNumber
    equipmentTypeId: number
    equipmentTypeName: string
    pointName
    sensorId: string
    sensorName
    sensorType

    sleepT
    dataUpload // 24h?
    thresholdName: string
    /**
     * APEF使用状态:
     */
    useLearnStatus: E_UseLearnStatus
    apefStartStatus: E_ApefStatus

    /**
     * 内联的阈值
     */
    sensorAlarmSettingList: ISensorAlarmSettingListItem[]
}

export type ISensorThreshPageData = IPageData<ISensorThreshPageItem>


export type ISensorThresholdGasPageListParams = ISensorThreshPageListParams

export type ISensorThresholdGasPageListData = ISensorThreshPageData


export type ISensorThresholdGdsPageListParams = ISensorThreshPageListParams

export type ISensorThresholdGdsPageListData = ISensorThreshPageData

export interface ISensorThresholdUpdateStatusParams {
    /**
     * 自诊断状态
     */
    faultStatus: E_FaultStatus
    sensorId: string
}

type ToRecord<T extends string> = {
    [key in T]: number
}
type Axis = 'X' | 'Y' | 'Z'
type Level = 'A' | 'B' | 'C' | 'D'
type LevelCD = 'C' | 'D'
type CdMax<T extends string> = ToRecord<`${T}${LevelCD}Max`>
type AbcdMax<T extends string> = ToRecord<`${T}${Level}Max`>
type XyzAbcdMax<T extends string> = ToRecord<`${T}${Axis}${Level}Max`>
type SlopeAxis<T extends string> = ToRecord<`${T}${Axis}Max`>

export type ISensorThresholdPartial =
    // 高频Z轴加速度
    AbcdMax<'aZHigh'> &
    // 电压
    CdMax<'batt'> &
    // 包络
    XyzAbcdMax<'envelope'> &
    // 峭度
    XyzAbcdMax<'kurt'> &
    // 波峰因数
    XyzAbcdMax<'peak'> &
    // 温度
    AbcdMax<'tem'> &
    // 振动
    XyzAbcdMax<'v'> &
    // 趋势
    SlopeAxis<'slope'> & {
        // 启停门限
        lowZSs: number
        highZSs: number
        /**
         * 传感器斜率报警状态
         */
        slopeStartStatus: E_SlopeStartStatus
    } &
    // 倾角
    CdMax<'r'>

export type ISensorThresholdEditAlarmParams =
    Partial<ISensorThresholdPartial> & {
        alarmThresholdId?: number
        useLearnStatus?: E_UseLearnStatus
        sensorIds: string[]
        mappingIds: number[]
        alarmTypeVOS: any[]
        learnStartTime?: string
        learnEndTime?: string
        openLearn?: E_StartStatus
    }


export type ISensorThresholdDetailData = ISensorThresholdPartial & {
    alarmThresholdId?: number
    useLearnStatus?: E_UseLearnStatus
    companyId: number
    areaId: number
    id: number
    sensorId: string
    isFault: E_YesNoNumber
    alarmTypeVOS: any[]
    learnStartTime?: string
    learnEndTime?: string
    openLearn: E_StartStatus

    /**
     * 传感器斜率报警学习开始时间
     */
    slopeLearnStartTime?: string

    /**
     * 传感器斜率报警学习结束时间
     */
    slopeLearnEndTime?: string
}

export interface ISensorThresholdUpdateAPEFStatusParams {
    mappingId: number
    apefStatus: E_ApefStatus
}
